SppHandler = App.loadClass 'grower::handlers/placement/SppHandler'

class exports.LegendCAEDGESoybeansHandler extends SppHandler

    init: () ->

        # note that @ is the SPP Handler, not the Step Handler
        @customStepFunctions =

            step_2:
                afterEnter: @stepFunctions.addExpectedYieldValidation

            step_4:
                afterEnter: @stepFunctions.addSoybeanMaturityValidation


        @hybridButtonContents =
            title: 'seed_company_name'
            table:
                'Brand': 'display_name'
                'Trait': 'trait_summary'
                'RM': 'soybean_maturity'

        @customButton =
            'html': '<button class="btn btn-primary" id="pdf_button" data-loading-text="Generating report...">
                    <i class="fa fa-file-o">
                </i> Summary Report</button>'
            'click': () =>
                layers = @curStep.stepKO.plantingPlans()
                @actionPdf(layers)

        # LEVEL UP!
        super()

    # This function will be passed into the Planting dialog controller via
    # PlantingOptions. "plan" is the Layer model used for the Plan tab.
    # "notes_obj" is the object used by the Notes tab.
    customPlantingPlan: (field_id, plan, notes_obj) =>
        products = @taffyObjects.hybrids

        pythium = @getFieldAspectByName(field_id, 'Pythium')?.value
        rhizoctonia = @getFieldAspectByName(field_id, 'Rhizoctonia')?.value

        @_customProductSubscription = (stage, product_id) ->
            product = products(id: parseInt(product_id)).first()

            t1 = product?.default_treatment_id
            t2 = product?.secondary_treatment_id
            if pythium or rhizoctonia
                stage.treatment = t2 ? t1
            else
                stage.treatment = t1
